package app.nestbridge.app.usecase

import com.karawek.core.auth.model.AuthSession
import com.karawek.core.auth.model.AuthenticatedUser
import app.nestbridge.app.context.identity.UserContext
import app.nestbridge.app.context.identity.UserContextProvider
import app.nestbridge.domain.identity.model.User
import app.nestbridge.domain.identity.model.UserStatus
import app.nestbridge.domain.identity.service.ProfessionalProfileService
import app.nestbridge.domain.identity.service.UserProfileService
import app.nestbridge.domain.identity.service.UserService
import me.tatarka.inject.annotations.Inject
import kotlin.time.Clock

@Inject
class LoadUserContextUseCase(
    private val userContextProvider: UserContextProvider,
    private val userService: UserService,
    private val userProfileService: UserProfileService,
    private val professionalProfileService: ProfessionalProfileService,
) {
    suspend operator fun invoke(
        session: AuthSession,
        authenticatedUser: AuthenticatedUser? = null,
    ): UserContext? {
        var user = userService.getCurrent()
        val now = Clock.System.now()

        if (user == null) {
            user = User(
                id = "",
                identityId = session.userId,
                // Existing sessions may not have fresh auth payload in memory.
                // Bootstrap from session so dependent profile loading can proceed.
                emails = authenticatedUser?.emailAddresses ?: emptyList(),
                phoneNumbers = authenticatedUser?.phoneNumbers ?: emptyList(),
                status = UserStatus.Active,
                createdAt = now,
                createdBy = session.userId,
                modifiedAt = now,
                modifiedBy = session.userId,
            )
            user = userService.save(user)
        }

        userContextProvider.set(UserContext(user = user))

        val userProfile = userProfileService.getCurrent()
        val professionalProfile = professionalProfileService.getCurrent()

        val userContext = UserContext(
            user = user,
            userProfile = userProfile,
            professionalProfile = professionalProfile,
        )

        userContextProvider.set(userContext)
        return userContext
    }
}
